import { ClientProfileViewModel } from '@common/model/client';
import { clientTypeToSuitableCatalogItemType } from '@common/utils/catalogType';
import { ClientSelection } from './clientSelection.interface';

export const clientProfileToSelection = (profile: ClientProfileViewModel): ClientSelection => ({
  careerId: profile.mainCareerId,
  catalogType: profile.type ? clientTypeToSuitableCatalogItemType(profile.type) : undefined,
  cityId: profile.cityId,
  clientType: profile.type,
  address: profile.address,
  name: profile.name,
});
